import { render, staticRenderFns } from "./faq.component.vue?vue&type=template&id=c503789c&"
import script from "./faq.component.ts?vue&type=script&lang=ts&"
export * from "./faq.component.ts?vue&type=script&lang=ts&"
import style0 from "./faq.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports